let config = {
    title: 'Jujutsu Kaisen: Shibuya Incident',
    email: 'support@jujutsukaisenshibuyaincident.com',
    policy: 'https://jujutsukaisenshibuyaincident.com/privacy_policy.html',
    term: 'https://jujutsukaisenshibuyaincident.com/terms.html', 
    copyright: '© 2024 Yunnan Cidu Network Technology Co., Ltd',
    introduceTitle: [
       `Welcome to the vast supernatural world of "Jujutsu Kaisen: Shibuya Incident"! You'll find yourself immersed in an engrossing RPG adventure where formidable curses reign and exploration of a detailed 3D realm awaits based on the acclaimed anime and manga series.`
    ],
    introduceText: [
        {
            title: '*A Stunningly Crafted World*',
            text: [
                `Traverse vividly realized 3D environments painstakingly inspired by Jujutsu Kaisen. From the lively bustle of Shibuya's urban sprawl to ominous otherworldly domains lurking in shadow, landscapes crafted with immense care will continuously captivate.`
            ]
        },
        {
            title: '*A Combat System Rich With Nuance*',
            text: [
                'Engage in thrilling battles with an intuitively designed system. Wield a diverse arsenal of attacks and sorcerous techniques to overcome malevolent curses and safeguard humanity in clashes requiring split-second decision making.'
            ]
        },
        {
            title: '*Memorable Characters Come To Life*',
            text: [
                'Inhabit beloved figures from the Jujutsu Kaisen mythos. Each possesses their own distinct strengths, weaknesses and fighting styles, necessitating careful consideration of who to bring into conflict with what foe.'
            ]
        },
        {
            title: '*An Immersive Narrative Unfolds*',
            text: [
                `Experience the chilling saga of the Shibuya Incident. Piece together clues and uncover revelations as the plot deeply develops, encountering allies new and old alongside formidable antagonists confronting humanity's darkest hours.`
            ]
        },
        {
            title: '*Customization To Suit Your Preferences*',
            text: [
                'Personalize appearances, weaponry and possessions of your characters with exclusive unlockables. Elevate abilities and forge a curse-combating team reflective of your singular vision through mastery of an expansive upgrade system.'
            ]
        },
        {
            title: '*Challenge Friends And Foes Online*',
            text: [
                `Test your mettle against others in multiplayer modes. Band together for cooperative missions or engage in competitive clashes, displaying your mastery earned over the game's countless foes.`
            ]
        }
    ]
}
export default config;